import React from 'react';
import Icon from './Icon';
import Pill from './Pill';
import MonthHeat from './MonthHeat';
import { typeLabel, typeAccent } from '../utils';

export default function CalendarNavigator({
  headerTitle,
  navFlash,
  granularity,
  setGranularity,
  stats,
  selectedDayItems,
  typeFilter,
  toggleType,
  quickAll,
  q,
  setQ,
  goPrev,
  goNext,
  goToday,
  simulateSystemEvent,
  filtered,
  cursor,
}) {
  return (
    <aside className="left">
      <div className="card">
        <div className="cardTop">
          <div>
            <div className="cardTitle">Navigator</div>
            <div className="cardSub">Month / Year switch • jump fast</div>
          </div>
          <div className="navBtns">
            <button className="iconBtn" onClick={goPrev} aria-label="Previous"><Icon name="chevL" /></button>
            <button className="iconBtn" onClick={goNext} aria-label="Next"><Icon name="chevR" /></button>
          </div>
        </div>
        <div className={`navTitle ${navFlash ? 'navFlash' : ''}`}>
          <div className="navMain">{headerTitle}</div>
          <div className="navPills">
            <button className={`mini ${granularity === 'month' ? 'miniOn' : ''}`} style={{ '--mini': 'var(--c-teal)' }} onClick={() => setGranularity('month')} aria-pressed={granularity === 'month'}>Month</button>
            <button className={`mini ${granularity === 'year' ? 'miniOn' : ''}`} style={{ '--mini': 'var(--c-violet)' }} onClick={() => setGranularity('year')} aria-pressed={granularity === 'year'}>Year</button>
            <button className="mini" style={{ '--mini': 'var(--c-cyan)' }} onClick={goToday}>Today</button>
          </div>
        </div>
        <div className="kpi">
          <div className="kpiBox">
            <div className="kpiN">{stats.total}</div>
            <div className="kpiL">Items in range</div>
          </div>
          <div className="kpiBox">
            <div className="kpiN">{selectedDayItems.length}</div>
            <div className="kpiL">Selected day</div>
          </div>
        </div>
        <div className="divider" />
        <div className="filters">
          <div className="filtersTop">
            <div className="filtersTitle"><Icon name="filter" /><span>Tags</span></div>
            <div className="filtersBtns">
              <button className="link" onClick={() => quickAll(true)}>All</button>
              <button className="link" onClick={() => quickAll(false)}>None</button>
            </div>
          </div>
          <div className="pillGrid">
            {['UserTask', 'Login', 'Order', 'Receive', 'Send', 'PasswordChange', 'Security', 'System'].map((t) => (
              <Pill key={t} label={typeLabel(t)} color={typeAccent(t)} active={typeFilter[t]} onClick={() => toggleType(t)} />
            ))}
          </div>
        </div>
        <div className="divider" />
        <div className="search">
          <div className="searchI"><Icon name="search" /></div>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search activity, notes, meta…" aria-label="Search" />
          {q ? <button className="iconBtn" onClick={() => setQ('')} aria-label="Clear search"><Icon name="x" /></button> : null}
        </div>
        <div className="divider" />
        <div className="sys">
          <div className="sysTop">
            <div className="sysTitle">System logger</div>
            <div className="sysSub">Simulate auto-saved events</div>
          </div>
          <div className="sysGrid">
            <button className="ghost" onClick={() => simulateSystemEvent('Login')}>Login</button>
            <button className="ghost" onClick={() => simulateSystemEvent('Order')}>Order</button>
            <button className="ghost" onClick={() => simulateSystemEvent('Receive')}>Receive</button>
            <button className="ghost" onClick={() => simulateSystemEvent('Send')}>Send</button>
            <button className="ghost" onClick={() => simulateSystemEvent('PasswordChange')}>PSW</button>
            <button className="ghost" onClick={() => simulateSystemEvent('Security')}>Security</button>
          </div>
        </div>
      </div>
      <div className="card">
        <MonthHeat monthDate={cursor} activities={filtered} />
      </div>
    </aside>
  );
}
